import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SlotRoutingModule } from './slot-routing.module';
import { SlotComponent } from './slot.component';
import { HttpClientModule } from '@angular/common/http';
import { CustomFlexLayoutModule } from 'src/app/flex-layout/custom-flex-layout.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { PipesModule } from 'src/app/theme/pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SlotDetailComponent } from './slot-detail/slot-detail.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';

const materialModules = [
  MatDatepickerModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatInputModule
];
@NgModule({
  declarations: [
    SlotComponent,
    SlotDetailComponent
  ],
  imports: [
    CommonModule,
    SlotRoutingModule,
    CustomFlexLayoutModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    HttpClientModule,
    PipesModule,
    MatDialogModule,
    MatDividerModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    FormsModule,
    MatToolbarModule,
    MatTableModule,
    MatDatepickerModule,
    MatSelectModule,
    materialModules

  ],exports:[
    SlotComponent
  ]
})
export class SlotModule { }
